import * as React from "react";
import GlobalStyles from "./GlobalStyles";
import Footer from "gatsby-theme-gallery/src/components/Footer";
import Header from "gatsby-theme-gallery/src/components/Header";

const Layout: React.FunctionComponent<{}> = ({ children }) => (
  <div>
    <GlobalStyles />
    <Header />
      {children}
    <Footer />

  </div>
);

export default Layout;
